/* eslint-disable no-extra-boolean-cast */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CAvatar,
  CContainer,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CHeader,
  CHeaderNav,
  CHeaderToggler,
  CNavItem,
} from '@coreui/react';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import React, { useEffect, useState } from 'react';
import { FcPrivacy } from 'react-icons/fc';
import { HiOutlineMenu } from 'react-icons/hi';
import { actionToggleSidebar } from 'redux/appConfig/actions';
import { selectAppSidebarShow } from 'redux/appConfig/selectors';
import { FaBell } from 'react-icons/fa';
import { Badge, Button, ButtonDropdown, Col, DropdownItem, DropdownMenu, DropdownToggle, Label, Row } from 'reactstrap';
import { get, map } from 'lodash';
import { useNavigate } from 'react-router-dom';
import routesMap from 'layouts/routesMap';
import { onGetDetailAction, onLogout } from 'utils/common';
import { getStorageData, STORAGE_KEY } from 'utils/storage';
import HeaderSearch from 'components/HeaderSearch';
import { GetInfoCustomer } from 'redux/thongTinTaiKhoan/action';
import { useSelector } from 'react-redux';
import { select_InfoCustomer_selector } from 'redux/thongTinTaiKhoan/selectors';
import { ActionGetCountTotalNoti, ActionGetListNoti, ActionUpdateStatusNoti } from 'redux/thongBao/action';
import moment from 'moment';
import { icon } from 'utils/constantImage';

const AppHeader: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate()
  const showSidebar = useAppSelector(selectAppSidebarShow);
  const infoCustomer = useSelector(select_InfoCustomer_selector || {})

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [infoUser, setInfoUser] = useState<any>({});
  const [totalNoti, setTotalNoti] = useState<number>(0);

  const [listNoti, setListNoti] = useState<ListNotiITF[]>([])

  const [dropdownOpenNotifications, setDropdownOpenNotifications] = useState<boolean>(false);

  const handleVisibleChange = () => {
    dispatch(actionToggleSidebar(!showSidebar));
  };

  async function getInfoUser() {
    const info = await getStorageData(STORAGE_KEY.USER_INFO)
    setInfoUser(info)
  }

  function getCountNoti() {
    dispatch(ActionGetCountTotalNoti({}, {
      onSuccess: (data: number) => {
        setTotalNoti(data);
        if(data > 0) {
          getListNoti();
        }
      },
      onFail: (error: any) => {
        setTotalNoti(0)
      }
    }))
  }

  function getListNoti() {
    const payload = {
      limit: 10,
      token: 1
    }
    dispatch(ActionGetListNoti(payload, {
      onSuccess: (data: ListNotiITF[]) => {
        setListNoti(data)
      },
      onFail: (error: any) => {
        setListNoti([])
      }
    }))
  }

  async function getInfoCustomerFNC() {
    const info = await getStorageData(STORAGE_KEY.USER_INFO)
    if(!!info) {
      dispatch(GetInfoCustomer())
    }
  }

  useEffect(() => {
    getInfoUser();
    getCountNoti();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if(!!infoCustomer) {
      getInfoCustomerFNC()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [infoUser])

  // function onLogout(): void {
  //   setStorageData(STORAGE_KEY.ACCESS_TOKEN, null);
  //   const auth = getAuth();
  //   signOut(auth).then(() => {
  //     // Sign-out successful.
  //   }).catch((error) => {
  //     // An error happened.
  //   });
  //   // window.location.reload()
  //   window.location.href = `${REACT_APP_URL_SSO}/logout?returnUrl=${encodeURIComponent(window.location.origin)}&version=${versionApp}&source=${sourceApp}`;
  // }

  const nameUser = !!infoCustomer?.fullName ? infoCustomer?.fullName : get(infoUser, 'full_name', '')
  const listName = nameUser.split(' ')

  function onNavigateConfig() {
    navigate(routesMap.CAU_HINH_TAI_KHOAN)
  }

  const renderAbount = () => {
    return (
      <CDropdown variant="nav-item">
        <CDropdownToggle className="py-0" caret={false}>
          <CAvatar color="warning" status="success" textColor="white">
            {listName[0].split('')[0]}{listName[listName.length - 1].split('')[0]}
          </CAvatar>
        </CDropdownToggle>
        <CDropdownMenu className="pt-0">
          <CDropdownHeader style={{ cursor: 'pointer' }} onClick={onNavigateConfig} className="bg-light fw-semibold py-2">Thông tin tài khoản</CDropdownHeader>

          {/* <CDropdownItem 
            onClick={onNavigateConfig}
          > */}
          {/* <HiOutlineUser size={20} style={{ marginTop: -5 }} /> */}
          {/* {get(infoUser,'full_name','')}
          </CDropdownItem> */}

          <CDropdownDivider />
          <CDropdownItem style={{ cursor: 'pointer' }} onClick={onLogout}>
            <FcPrivacy size={20} style={{ marginTop: -5 }} />
            Đăng xuất
          </CDropdownItem>
        </CDropdownMenu>
      </CDropdown>
    );
  };

  const toggleDropdownOpenNotifications = (): void => {
    setDropdownOpenNotifications(!dropdownOpenNotifications);
  };

  function onClickNotiScreen(): void {
    navigate(routesMap.THONG_BAO)
    toggleDropdownOpenNotifications()
  }

  function updateStatusNoti(itemUpdate: ListNotiITF) {
    if (itemUpdate?.status !== 1) {
      return
    }
    dispatch(ActionUpdateStatusNoti(itemUpdate?.id, {
      onSuccess: () => {
        const listNotiNew = map(listNoti, item => {
          return {
            ...item,
            status: item?.id === itemUpdate?.id ? 2 : item?.status
          }
        })
        setListNoti(listNotiNew);
      }
    }))
  }

  function onCLickNoti(itemUpdate: ListNotiITF) {
    updateStatusNoti(itemUpdate);
    onGetDetailAction(itemUpdate);
  }

  const renderHeaderNotifications = (): JSX.Element => {
    return (
      <ButtonDropdown isOpen={dropdownOpenNotifications} toggle={toggleDropdownOpenNotifications}>
        <DropdownToggle nav>
          <FaBell size={25} />
          <Badge pill color="danger">
            {totalNoti}
          </Badge>
        </DropdownToggle>
        <DropdownMenu right>
          <Label style={{ paddingLeft: 10 }}>Thông báo mới</Label>
          <div style={{ maxHeight: 300, overflow: 'auto' }}>
            {map(listNoti, (item, index) => {
              return (
                <div key={index.toString()}
                  onClick={() => onCLickNoti(item)}
                >
                  <DropdownItem divider />
                  <DropdownItem>
                    <Row>
                      <div style={{ width: 35 }}>
                        <img src={icon.iconLogoApp} style={{width: 35, height: 35}} className="img-avatar" alt="VTPostek" />
                      </div>
                      <Col>
                        <span style={{ whiteSpace: 'break-spaces', fontWeight: 'bold' }}>
                          {item?.title}
                        </span>
                        <br />
                        <span>{moment(new Date(item?.created_date || '')).format('DD/MM HH:mm')}</span>
                        <br />
                        <span style={{ whiteSpace: 'break-spaces' }}>
                          {item?.content}
                        </span>
                      </Col>
                    </Row>
                  </DropdownItem>
                </div>
              )
            })}
          </div>
          <DropdownItem divider />
          <div style={{ textAlign: 'center' }}>
            <Button onClick={onClickNotiScreen} className='btn-viettel'>Xem tất cả thông báo</Button>
          </div>
        </DropdownMenu>
      </ButtonDropdown>
    );
  };

  return (
    <CHeader position="sticky">
      <CContainer fluid>
        <Row style={{alignItems: 'center'}}>
          <Col>
            <CHeaderToggler className="ps-1">
              <HiOutlineMenu size={25} onClick={handleVisibleChange} />
            </CHeaderToggler>
          </Col>
          <Col>
            <HeaderSearch />
          </Col>
        </Row>

        <CHeaderNav className="ms-3 align-items-center">
          <CNavItem className="sipHeaderNoti">
            {renderHeaderNotifications()}
          </CNavItem>
          <span style={{ cursor: 'pointer' }}>
            {nameUser}
          </span>
          <CNavItem>
            {renderAbount()}
          </CNavItem>
        </CHeaderNav>
      </CContainer>
    </CHeader>
  );
};

export default AppHeader;
